import { Carousel } from 'antd';
import styled from 'styled-components';

const CarouselWrapper = styled.div`
  .ant-carousel .slick-slider .slick-dots {
    display: inline-table !important;
    top: 75%;
    padding-left: 4%;
  }

  .ant-carousel .slick-slider .slick-dots li button {
    background: #dedede;
    opacity: 5;
    height: 10px;
    width: 10px;
    background-color: #bbb;
    border-radius: 50%;
    justify-items: start;
  }

  .ant-carousel .slick-slider .slick-dots li.slick-active button {
    background: var(--color-primary) 0% 0% no-repeat padding-box;
  }
`;

function EbzCarousel({ ...props }) {
  return (
    <CarouselWrapper>
      <Carousel {...props} />
    </CarouselWrapper>
  );
}
export default EbzCarousel;
